import React from 'react';
import ImportacoesListPage from "../../components/importacoes/ImportacoesListPage";

export default function Index() {
    return (
        <ImportacoesListPage
            title="Obrigações"
            subtitle="Histórico de importações de guias fiscais."
            listEndpoint="listar/importacoes"
            importarPath="/obrigacoes/importar-guias"
            detalhesPath="/obrigacoes/detalhes-importacao"
        />
    );
}
